import React from 'react'

function EditReport() {
  return (
    <div>
      
    </div>
  )
}

export default EditReport
